import React from "react";

import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const LibrarySkeleton: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Skeleton variant="rounded" width={240} height={32} />
      </Grid>
      {Array(4)
        .fill(0)
        .map((_, index) => (
          <Grid key={index} size={12}>
            <Skeleton variant="rounded" height={300}/>
          </Grid>
        ))}
    </Grid>
  );
};
